var path = 'app/reporting/shared/nothingToShow.html';
var html = "<div class=\"reporting_nothing-to-show-cnt\">\n  {{\"reporting.labels.noDataSelectedToShow\" | i18n}}\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;